/**
 * Navigation — Daisy Connected Shop
 * Burger toggle, mobile nav slide-down, scroll lock, escape key.
 */

(function () {
  'use strict';

  var burger = document.querySelector('.burger-menu');
  var mobileNav = document.getElementById('mobile-nav');

  if (!burger || !mobileNav) return;

  var isOpen = false;

  function open() {
    isOpen = true;
    burger.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label',
      document.documentElement.lang === 'en' ? 'Close navigation menu' : 'Close menu');
    mobileNav.hidden = false;

    /* Allow reflow before adding visible class for transition */
    requestAnimationFrame(function () {
      mobileNav.classList.add('mobile-nav--visible');
    });

    document.body.style.overflow = 'hidden';
  }

  function close() {
    isOpen = false;
    burger.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label',
      document.documentElement.lang === 'en' ? 'Open navigation menu' : 'Open menu');
    mobileNav.classList.remove('mobile-nav--visible');

    document.body.style.overflow = '';

    /* Hide after transition ends */
    mobileNav.addEventListener('transitionend', function handler() {
      if (!isOpen) {
        mobileNav.hidden = true;
      }
      mobileNav.removeEventListener('transitionend', handler);
    });
  }

  function toggle() {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }

  burger.addEventListener('click', toggle);

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      close();
      burger.focus();
    }
  });

  /* Close when clicking a nav link */
  mobileNav.addEventListener('click', function (e) {
    if (e.target.closest('.mobile-nav__link')) {
      close();
    }
  });
})();
